export const configs = {
  DASHBOARD_API: process.env.REACT_APP_API_BASE_URL || '',
  ENABLE_INVESTMENT_MFE: process.env.REACT_APP_ENABLE_INVESTMENT_MFE === 'true',
  INVESTMENT_MFE_ENTRY_POINT: process.env.REACT_APP_INVESTMENT_MFE_ENTRY_POINT || '',
  ENABLE_CASH_ACCOUNT: process.env.REACT_APP_ENABLE_CASH_ACCOUNT === 'true',
  OPPORTUNITY_DETAILS_MFE_ENTRY_POINT: process.env.REACT_APP_OPPORTUNITY_DETAILS_MFE_ENTRY_POINT || '',
  ENABLE_OPPORTUNITY_DETAILS_MFE: process.env.REACT_APP_ENABLE_OPPORTUNITY_DETAILS_MFE === 'true',
};
